<script setup lang="ts">
import Server from '@/core/resources/Server'

defineProps({
  server: {
    type: Object as () => Server,
    required: true
  }
})
const selected = defineModel<boolean>()

defineEmits({
  edit: null,
  delete: null
})
</script>

<template>
  <tr :class="{ selected: selected }">
    <td>
      <input type="checkbox" v-model="selected" />
    </td>
    <td class="name-column">
      <span>
        {{ server.name }}
      </span>
    </td>
    <td class="hostname-column">
      <span>
        {{ server.hostname }}
      </span>
    </td>
    <td class="username-column">
      <span>
        {{ server.username }}
      </span>
    </td>
    <td>
      <span class="material-symbols-outlined action edit-button" @click="$emit('edit')">edit</span>
      <span class="material-symbols-outlined action delete-button" @click="$emit('delete')">delete</span>
    </td>
  </tr>
</template>

<style scoped lang="scss">
@import '@/assets/styles/tableline.scss';
</style>
